
export default [
  {
    name: 'SOCKET_LOGIN',
    callback: function (data) {
      console.log(data)
      this.$socket.emit('chatlogin', data)
    }
  },
  {
    name: 'SOCKET_LOGON',
    callback: function (data) {
      this.$socket.emit('logon', data)
    }
  },
  {
    name: 'APP_LOGIN_SUCCESS',
    callback: function () {
      this.$router.push({ path: '/home' })
    }
  },
  {
    name: 'APP_LOGOUT',
    callback: function () {
      localStorage.clear()
      this.$router.push({ path: '/login' })
    }
  },
  {
    name: 'MENU_ADM_TOPUP',
    callback: function () {
      this.$router.push({ path: '/cashin' })
    }
  },
  {
    name: 'MENU_ADM_CASHOUT',
    callback: function () {
      this.$router.push({ path: '/cashout' })
    }
  },
  {
    name: 'MENU_ADM_SALDO',
    callback: function () {
      this.$router.push({ path: '/account' })
    }
  },
  {
    name: 'MENU_ADM_USER',
    callback: function () {
      this.$router.push({ path: '/usermanagement' })
    }
  },
  {
    name: 'MENU_ADM_MUTASIBANK',
    callback: function () {
      this.$router.push({ path: '/mutasibank' })
    }
  },
  {
    name: 'MENU_ADM_SLIDER',
    callback: function () {
      this.$router.push({ path: '/admin/sliders' })
    }
  },
  {
    name: 'MENU_ADM_PRODUK',
    callback: function () {
      this.$router.push({ path: '/admin/products' })
    }
  },
  {
    name: 'CONF_DEPOSIT',
    callback: function (data) {
      this.$router.push({ path: '/confmdeposit/' + data.data.invoice })
    }
  },
  {
    name: 'INVOICE_CC_RESP',
    callback: function (data) {
      console.log(data)
      window.open(data.data.invoiceUrl, '_blank')
      // this.$router.push({ path: '/confmdeposit/' + data.data.invoice })
    }
  },
  {
    name: 'APP_INFO',
    callback: function (msg) {
      console.log(msg)
      this.$store.dispatch('alert/success', 'Pesan Terkirim', { root: true })
    }
  },

  {
    name: 'APP_INFO_ERROR',
    callback: function (msg) {
      this.snackbar = {
        show: true,
        color: 'red',
        text: msg
      }
    }
  },
  {
    name: 'APP_PAGE_LOADED',
    callback: function () {
    }
  },
  {
    name: 'APP_AUTH_FAILED',
    callback: function () {
      this.$router.push({ path: '/login' })
      this.$message.error('Token has expired')
    }
  },
  {
    name: 'APP_CHANNGE_PASSWORD',
    callback: function () {
      this.$router.push('/gantipassword')
    }
  },
  {
    name: 'DONE_UPLOAD_PROFILE',
    callback: function (url) {
      console.log(url)
      this.$store.dispatch('authentication/setProfileImage', url, { root: true })
    }
  },
  {
    name: 'DONE_UPLOAD_KTP',
    callback: function (url) {
      this.$store.dispatch('SellerStore/setsellerktp', url, { root: true })
    }
  },
  {
    name: 'DONE_UPLOAD_NPWP',
    callback: function (url) {
      this.$store.dispatch('SellerStore/setsellernpwp', url, { root: true })
    }
  },
  {
    name: 'APP_PROFILE',
    callback: function () {
      this.$router.push('/profile')
    }
  },
  {
    name: 'TRX_BELI',
    callback: function () {
      this.$router.push('/trxpembelian')
    }
  },
  {
    name: 'TRX_JUAL',
    callback: function () {
      this.$router.push('/penjualan')
    }
  },
  {
    name: 'REG_SELLER',
    callback: function () {
      this.$router.push('/regseller')
    }
  },
  {
    name: 'APP_BAD_REQUEST',
    // @error api response data
    callback: function (msg) {
      this.$message.error(msg)
    }
  },
  {
    name: 'APP_ACCESS_DENIED',
    // @error api response data
    callback: function (msg) {
      this.snackbar = {
        show: true,
        color: 'red',
        text: msg
      }
      this.$router.push({ path: '/login' })
    }
  },
  {
    name: 'APP_RESOURCE_DELETED',
    // @error api response data
    callback: function (msg) {
      this.$message.success(msg)
    }
  },
  {
    name: 'APP_RESOURCE_UPDATED',
    // @error api response data
    callback: function (msg) {
      this.$message.success(msg)
    }
  },
  {
    name: 'APP_DRAWER_TOGGLED',
    callback: function () {
      this.$store.dispatch('authentication/stateDrawer')
    }
  },
  {
    name: 'APP_TOPUPSALDO',
    callback: function () {
      this.$store.dispatch('SaldoStore/setdialogtopupsaldo', true)
    }
  },
  {
    name: 'REFRESH_SELLER_PAGE',
    callback: () => {
      console.log('REFRESH_SELLER_PAGE')
      this.$store.dispatch('ProductMapping/getProductMapping', this.$route.params.id)
    }
  }
]
